import React from 'react';

export const NewMainTabs = ({ tabs, activeTab, onChange }) => {
  return (
    <div className="flex items-center gap-6 border-b border-slate-200 pb-0">
      {tabs.map((tab) => {
        const isActive = activeTab === tab.id;
        return (
          <button
            key={tab.id}
            onClick={() => onChange(tab.id)}
            className={`flex items-center gap-1.5 pb-3 px-1 text-[13px] transition-all border-b-2 cursor-pointer ${
              isActive
                ? 'border-[#C91D25] text-[#C91D25] font-bold'
                : 'border-transparent text-slate-400 font-semibold hover:text-slate-600'
            }`}
          >
            {tab.icon}
            {tab.label}
          </button>
        );
      })}
    </div>
  );
};

export const NewSubTabs = ({ tabs, activeTab, onChange, customPadding = "pb-3" }) => {
  return (
    <div className="flex items-center gap-6 border-b border-slate-200 overflow-x-auto custom-scrollbar pt-2">
      {tabs.map((tab) => {
        const isActive = activeTab === tab.id;
        return (
          <button
            key={tab.id}
            onClick={() => onChange(tab.id)}
            className={`${customPadding} px-1 text-xs whitespace-nowrap transition-all border-b-2 cursor-pointer ${
              isActive
                ? 'border-[#C91D25] text-[#C91D25] font-bold'
                : 'border-transparent text-slate-500 font-semibold hover:text-slate-700'
            }`}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
};
